import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

export const SmartlinksMusicIndustryElement: React.FC<{ label: string }> = ({ label }) => {
  return (
    <div className="d-flex align-items-center justify-content-center smartlinks-music-industries-slider-element">
      {label}
    </div>
  );
};
export const SmartlinksMusicIndustriesList: React.FC = () => {
  const intl = useIntl();
  const musicIndustryElements = useMemo(
    () => [
      intl.formatMessage({
        id: 'sml.web.smartlinks.description.music-industry.artists',
        defaultMessage: 'Artists'
      }),
      intl.formatMessage({
        id: 'sml.web.smartlinks.description.music-industry.music-curators',
        defaultMessage: 'Music curators'
      }),
      intl.formatMessage({
        id: 'sml.web.smartlinks.description.music-industry.djs',
        defaultMessage: 'DJs'
      }),
      intl.formatMessage({
        id: 'sml.web.smartlinks.description.music-industry.bands',
        defaultMessage: 'Bands'
      }),
      intl.formatMessage({
        id: 'sml.web.smartlinks.description.music-industry.festivals',
        defaultMessage: 'Festivals'
      }),
      intl.formatMessage({
        id: 'sml.web.smartlinks.description.music-industry.labels',
        defaultMessage: 'Labels'
      }),
      intl.formatMessage({
        id: 'sml.web.smartlinks.description.music-industry.musicians',
        defaultMessage: 'Musicians'
      }),
      intl.formatMessage({
        id: 'sml.web.smartlinks.description.music-industry.radio-stations',
        defaultMessage: 'Radio stations'
      }),
      intl.formatMessage({
        id: 'sml.web.smartlinks.description.music-industry.businesses',
        defaultMessage: 'Businesses'
      })
    ],
    [intl]
  );
  return (
    <div className="smartlinks-music-industries d-flex flex-wrap flex-row justify-content-center">
      {musicIndustryElements.map((musicIndustry) => (
        <SmartlinksMusicIndustryElement label={musicIndustry} key={musicIndustry} />
      ))}
    </div>
  );
};
